import { useState, ReactElement } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import AddCircleOutline from '@mui/icons-material/AddCircleOutline';

import Button from '~/ui/components/common/Button';
import AddNotificationRuleForm from '~/ui/components/reusable/ProgramForm/components/AddNotificationRuleForm';
import { typeOptions } from '~/ui/constants/notificationRule';
import styles from './RulesFooter.module.scss';
import { INotificationRule } from '~/services/api/notificationRules/types';

interface IProps {
  notificationRules: INotificationRule[];
  isSaving: boolean;
  onAddRule: (rule: INotificationRule) => Promise<boolean>;
}

const RulesFooter = ({ notificationRules, isSaving, onAddRule }: IProps): ReactElement => {
  const [showAddNotificationRule, setShowAddNotificationRule] = useState(false);

  const disabledButton = notificationRules.length === typeOptions.length * 2;

  const addNotificationRule = async (rule: INotificationRule) => {
    const isAdded = await onAddRule(rule);

    if (isAdded) {
      setShowAddNotificationRule(false);
    }
  };

  return (
    <div className={styles.footerContent}>
      {showAddNotificationRule ? (
        <AddNotificationRuleForm
          rules={notificationRules}
          onSubmit={addNotificationRule}
          onCancel={() => setShowAddNotificationRule(false)}
        />
      ) : (
        <Tooltip title={disabledButton ? 'The maximum number of notification rules used' : ''}>
          <span>
            <Button
              size="small"
              variant="outlined"
              color="primary"
              startIcon={<AddCircleOutline />}
              disabled={disabledButton || isSaving}
              onClick={() => setShowAddNotificationRule(true)}
            >
              Add More
            </Button>
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default RulesFooter;
